import { render, staticRenderFns } from "./IdiomPager.vue?vue&type=template&id=3231cd52&scoped=true&"
import script from "./IdiomPager.vue?vue&type=script&lang=js&"
export * from "./IdiomPager.vue?vue&type=script&lang=js&"
import style0 from "./IdiomPager.vue?vue&type=style&index=0&id=3231cd52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3231cd52",
  null
  
)

export default component.exports